import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http'
import { EMPTY, Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import { AuthService } from './auth.service'
import { Injectable, inject } from '@angular/core'
import { LOAN_STORAGE, SharedService } from './shared.service'
import { environment } from '@environments/environment'

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private router = inject(Router)
  private auth = inject(AuthService)
  private sharedService = inject(SharedService)

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      headers: req.headers
        .append('version', '3.0.0')
        .append('brand', environment.brand)
        .append(
          'service-id',
          this.auth.customer()
            ? this.auth.isNewCustomer
              ? String(environment.serviceId)
              : String(environment.serviceIdOld)
            : String(environment.serviceId),
        )
        .append('source', environment.appHost),
    })

    if (req.url.startsWith('/api/') || req.url.startsWith('/restapi/')) {
      req = req.clone({ url: `${environment.apiHost}${req.url}` })
    }

    if (req.url.includes('/api/') || req.url.includes('/restapi/')) {
      const customer = this.auth.customer()
      if (customer) {
        req = req.clone({ headers: req.headers.set('Token', /*istanbul ignore next*/ customer.token) })

        // istanbul ignore next
        if (req.url.includes('/public/v1/track/navigation') || req.url.includes('/public/v1/track/data')) {
          req = req.clone({ headers: req.headers.set('X-CUSTOMER', String(customer.id)) })
        }
      } else {
        req = req.clone({ headers: req.headers.set('X-CUSTOMER', 'null') })
      }
    }

    const loan = this.sharedService.getData(LOAN_STORAGE)
    if (loan) {
      req = req.clone({ headers: req.headers.set('X-LOAN', String(loan.id)) })
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let throwErrorFlag = false
        switch (error.status) {
          case HttpStatusCode.UnprocessableEntity:
            this.router.navigateByUrl('/error')
            break
          case HttpStatusCode.Forbidden:
          case HttpStatusCode.Unauthorized:
            this.auth.logout()
            break
          default:
            throwErrorFlag = true
        }
        return throwErrorFlag ? throwError(() => error) : EMPTY
      }),
    )
  }
}
